module.exports = __webpack_public_path__ + "img/open_in_new.90e755a8.svg";